import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
    Box,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
} from '@material-ui/core';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import { TFilters } from './filters.types';
import {
    StyledFormControl,
    StyledIncidentCategory,
    StyledLabel,
} from './filters.styled';

import { dateToString, updateUrlParameters } from '@helpers';

export function Filters({
    filter,
    setFilter,
    categoryOptions,
    hideCategoriesFilters,
}: TFilters) {
    const { fromDate, toDate, category } = filter;

    const handleCategoryChange = event => {
        setFilter({ ...filter, category: event.target.value });
        const urlCategory = event.target.value;
        updateUrlParameters({ category: urlCategory });
    };

    const handleDateFromChange = date => {
        if (date == 'Invalid Date') return;
        setFilter({ ...filter, fromDate: date });
        const urlDate = dateToString(date);
        if (urlDate == undefined) return;
        updateUrlParameters({ fromDate: urlDate });
    };

    const handleDateToChange = date => {
        if (date == 'Invalid Date') return;
        setFilter({ ...filter, toDate: date });
        const urlDate = dateToString(date);
        if (urlDate == undefined) return;
        updateUrlParameters({ toDate: urlDate });
    };

    return (
        <Box pt={2}>
            <StyledFormControl as="fieldset">
                <FormLabel component="legend">DATE RANGE</FormLabel>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        variant="inline"
                        inputVariant="outlined"
                        margin="dense"
                        id="From"
                        label="From"
                        format="dd/MM/yyyy"
                        value={fromDate}
                        onChange={handleDateFromChange}
                        maxDate={toDate}
                        KeyboardButtonProps={{
                            'aria-label': 'change from date',
                        }}
                        autoOk={true}
                    />
                    <KeyboardDatePicker
                        variant="inline"
                        inputVariant="outlined"
                        margin="dense"
                        id="To"
                        label="To"
                        format="dd/MM/yyyy"
                        value={toDate}
                        onChange={handleDateToChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change to date',
                        }}
                        autoOk={true}
                    />
                </MuiPickersUtilsProvider>
            </StyledFormControl>
            {!hideCategoriesFilters && (
                <StyledFormControl as="fieldset">
                    <FormLabel component="legend">CATEGORIES</FormLabel>
                    <RadioGroup
                        aria-label="Category"
                        name="Category"
                        value={category}
                        onChange={handleCategoryChange}
                    >
                        {categoryOptions.map((categoryOption, index) => {
                            const IconComponent = categoryOption.icon;
                            const isActive = categoryOption.value === category;

                            return (
                                <FormControlLabel
                                    key={index}
                                    value={categoryOption.value}
                                    control={<Radio size="small" />}
                                    label={
                                        <StyledLabel
                                            style={{
                                                color: isActive
                                                    ? categoryOption.colour
                                                    : 'inherit',
                                            }} // dynamic color
                                        >
                                            <IconComponent
                                                width={24}
                                                height={24}
                                            />
                                            <StyledIncidentCategory component="span">
                                                {categoryOption.label}
                                            </StyledIncidentCategory>
                                        </StyledLabel>
                                    }
                                />
                            );
                        })}
                    </RadioGroup>
                </StyledFormControl>
            )}
        </Box>
    );
}
